import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import DropdownStyles from '@stories/Components/Misc/Dropdown/Dropdown.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  margin: var(--sectionPadding) 0;
`;
const Filters = styled.div `
  --filterGap: ${fluid(8, 40)};

  display: grid;
  place-content: center;
  grid-template-columns: repeat(3, 33%);
  gap: var(--filterGap);
  margin: ${fluid(24, 72)} 0 ${fluid(45, 64)};

  @media ${until(Device.MobileLarge)} {
    ${DropdownStyles.Container}::after {
      display: none;
    }

    ${DropdownStyles.Select} {
      padding: 0 12px;
      text-align: center;
    }
  }

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(3, 25%);
  }
`;
const ResultsContainer = styled.div `
  position: relative;
`;
const ResultsAmount = styled.div `
  ${fonts.brandonGrotesque.regular};
  font-size: ${fluid(20, 22)};
  line-height: 1.5;
  margin-bottom: 24px;
  text-align: center;

  @media ${from(Device.Tablet)} {
    margin-bottom: 18px;
    text-align: left;
  }
`;
const ResultsCount = styled.span `
  ${fonts.brandonGrotesque.bold};
`;
const ResultsWrapper = styled.div `
  display: grid;
  gap: ${fluid(32, 40)};

  @media ${from(Device.MobileLarge)} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const RangeListingStyles = {
    Container,
    Filters,
    ResultsAmount,
    ResultsContainer,
    ResultsCount,
    ResultsWrapper,
};
export default RangeListingStyles;
